import { useEffect, useState } from "react";

export default function useIsInPWA() {
  const [isInPWA, setIsInPWA] = useState(false);

  useEffect(() => {
    const checkPWA = () => {
      const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
      const isIOSStandalone = (window.navigator as any).standalone === true; // iOS Safari
      setIsInPWA(isStandalone || isIOSStandalone);
    };

    checkPWA();

    // ascultă schimbările de display-mode (rare, dar posibile)
    const mq = window.matchMedia("(display-mode: standalone)");
    mq.addEventListener("change", checkPWA);

    return () => mq.removeEventListener("change", checkPWA);
  }, []);

  return isInPWA;
}
